module.exports = __webpack_public_path__ + "static/img/20231208_04.1f4207e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2023/20231208_04.png
// module id = lIHO
// module chunks = 0